<div class="item">
  <p
    class="text rounded-full transition-colors"
    [attr.data-text]="textColor()"
    [attr.data-background]="backgroundColor()"
  >
    {{ day().format('DD') }}
  </p>
</div>
